import React from "react";
import Navbar from "../Navbar";
import "../css/newspage.css";
import { Link } from "react-router-dom";

import "bootstrap/dist/css/bootstrap.css";
import "bootstrap/dist/js/bootstrap.bundle";
export const NewsPage = () => {
  return (
    <>
      <Navbar />
      <>
        <div className="news-showup">
          <div className="row" id="row1">
            {/* Main Articles */}
            <div className="col-md-8">
              <div className="row mb-3">
                <div className="col-md-6">
                  <div id="car">
                    <Link to="/united-passenger-fined">
                      <img
                        src="./images/united-passenger.jpg"
                        className="card-img-top"
                        alt="News Image"
                      />
                    </Link>
                    <div className="card-body">
                      <Link to="/united-passenger-fined">
                        <h5 className="card-title">
                          United Passenger Fined $10K for Urinating in Seat
                          Mid-Flight After Mixing Xanax and Alcohol
                        </h5>
                      </Link>
                      <p className="text-muted">January 7, 2025</p>
                    </div>
                  </div>
                </div>
                <div className="col-md-6">
                  <div id="car">
                    <Link to="">
                      <img
                        src="./images/trump.png"
                        className="card-img-top"
                        alt="News Image"
                      />
                    </Link>
                    <div className="card-body">
                      <Link to="">
                        <h5 className="card-title">
                          Shake Shack Introduces Limited-Time $9 'NYC Congestion
                          Pricing Combo' in Tri-State Area
                        </h5>
                      </Link>
                      <p className="text-muted">January 7, 2025</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {/* Sidebar Articles */}
            <div className="col-md-4">
              <div className="row mb-3">
                <div className="col-12">
                  <div className="dflex">
                    <div className="h1div">
                      <Link to="/key-factors-behind-the-israel-hamas-ceasefire-deal">
                        <h6 className="mb-0">
                        Key Factors Behind the Israel-Hamas Ceasefire Deal in Gaza: What You Need to Know.
                        </h6>
                      </Link>
                      <p className="text-muted">January 7, 2025</p>
                    </div>
                    <Link to="/key-factors-behind-the-israel-hamas-ceasefire-deal">
                      <img
                        src="./images/trump.png"
                        className="me-3"
                        alt="News Image"
                      />
                    </Link>
                  </div>
                </div>
              </div>
              <div className="row mb-3">
                <div className="col-12">
                  <div className="dflex">
                    <div className="h1div">
                      <Link to="new-york-traffic-drops">
                        <h6 className="mb-0">
                        Former UK Minister: Rebuilding Gaza Will Be 'Impossibly Difficult'
                        </h6>
                      </Link>
                      <p className="text-muted">January 17, 2025</p>
                    </div>
                    <Link to="new-york-traffic-drops">
                      <img
                        src="./images/trump.png"
                        className="me-3"
                        alt="News Image"
                      />
                    </Link>
                  </div>
                </div>
              </div>
              <div className="row mb-3">
                <div className="col-12">
                  <div className="dflex">
                    <div className="h1div">
                      <Link to="/toyota-subsidiary-agrees">
                        <h6 className="mb-0">
                        Toyota Subsidiary Agrees to $1.6 Billion Settlement in Emissions Scandal.
                        </h6>
                      </Link>
                      <p className="text-muted">January 7, 2025</p>
                    </div>
                    <Link to="/toyota-subsidiary-agrees">
                      <img
                        src="./images/navnews/toyota.png"
                        className="me-3"
                        alt="News Image"
                      />
                    </Link>
                  </div>
                </div>
              </div>
              <div className="row mb-3">
                <div className="col-12">
                  <div className="dflex" id="dflex1">
                    <div className="h1div">
                      <Link to="/tik-tok-faces-u.s.ban-by-sunday">
                        <h6 className="mb-0">
                        Supreme Court Rejects Appeal, TikTok Faces U.S. Ban by Sunday.
                        </h6>
                      </Link>
                      <p className="text-muted">January 17, 2025</p>
                    </div>
                    <Link to="/tik-tok-faces-u.s.ban-by-sunday">
                      <img
                        src="./images/navnews/tik-tok.jpg"
                        className="me-3"
                        alt="News Image"
                      />
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="news-sidebar">
          <div className="news-headline">
            <div className="namee">
              <div className="row mb-3">
                <div className="col-12">
                  <div className="mflex">
                    <div className="hdiv">
                      <Link to="/investec-issues-hold">
                        <h6 className="mb-0">
                        Investec Issues 'Hold' Rating for Ola Electric, Cautions About Challenges Ahead.
                        </h6>
                      </Link>
                      <p className="text-muted">January 7, 2025</p>
                    </div>
                    <Link to="/investec-issues-hold">
                      <img
                        src="./images/navnews/ola-ele.jpeg"
                        className="me-3"
                        alt="News Image"
                      />
                    </Link>
                  </div>
                </div>
              </div>
              <div className="row mb-3">
                <div className="col-12">
                  <div className="mflex">
                    <div className="hdiv">
                      <Link to="/apple's-record">
                        <h6 className="mb-0">
                        Apple Nears Record $4 Trillion Market Cap, Driven by AI Growth.
                        </h6>
                      </Link>
                      <p className="text-muted">January 7, 2025</p>
                    </div>
                    <Link to="/apple's-record">
                      <img
                        src="./images/navnews/apple.jpg"
                        className="me-3"
                        alt="News Image"
                      />
                    </Link>
                  </div>
                </div>
              </div>
            </div>
            <div className="namee">
              <div className="row mb-3">
                <div className="col-12">
                  <div className="mflex">
                    <div className="hdiv">
                      <Link to="/bitcoin-surpasses-$100000-for-the-first-time">
                        <h6 className="mb-0">
                          Bitcoin Surpasses $100,000 for the First Time
                          Following Pro-Crypto SEC Chair Appointment by Trump
                        </h6>
                      </Link>
                      <p className="text-muted">January 7, 2025</p>
                    </div>
                    <Link to="/bitcoin-surpasses-$100000-for-the-first-time">
                      <img
                        src="./images/trump.png"
                        className="me-3"
                        alt="News Image"
                      />
                    </Link>
                  </div>
                </div>
              </div>
              <div className="row mb-3">
                <div className="col-12">
                  <div className="mflex">
                    <div className="hdiv">
                      <Link to="/is-onlyfans-now-available-in-china">
                        <h6 className="mb-0">
                          Is OnlyFans Now Available in China? Here's What You
                          Need to Know
                        </h6>
                      </Link>
                      <p className="text-muted">January 7, 2025</p>
                    </div>
                    <Link to="/is-onlyfans-now-available-in-china">
                      <img
                        src="./images/trump.png"
                        className="me-3"
                        alt="News Image"
                      />
                    </Link>
                  </div>
                </div>
              </div>
            </div>
            <div className="namee">
              <div className="row mb-3">
                <div className="col-12">
                  <div className="mflex">
                    <div className="hdiv">
                      <Link to="/meta-india-apologizes">
                        <h6 className="mb-0">
                          Meta India Apologizes for CEO Zuckerberg's Comment on
                          India Elections, Calls it an Unintentional Mistake
                        </h6>
                      </Link>
                      <p className="text-muted">January 7, 2025</p>
                    </div>
                    <Link to="/meta-india-apologizes">

                    <img
                      src="./images/trump.png"
                      className="me-3"
                      alt="News Image"
                    />
                    </Link>
                  </div>
                </div>
              </div>
              <div className="row mb-3">
                <div className="col-12">
                  <div className="mflex">
                    <div className="hdiv">
                      <Link to="/weakening-rupee-raises">
                        <h6 className="mb-0">
                          Weakening Rupee Raises Uncertainty Over India's
                          Potential Interest Rate Cuts
                        </h6>
                      </Link>
                      <p className="text-muted">January 7, 2025</p>
                    </div>
                    <Link to="/weakening-rupee-raises">
                    <img
                      src="./images/trump.png"
                      className="me-3"
                      alt="News Image"
                    />
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="advertise-container"></div>
        </div>
      </>
    </>
  );
};
